import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { guides } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="system-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-202" data-mp="3y1u6vfkgr2m">
      <div className="mx-auto max-w-6xl" data-id="element-203" data-mp="7yu0bft56fuo">
        <SectionHeading id="system-heading" eyebrow="The Complete Teaching Library" title={<>
              6 Volumes. <Accent data-id="element-205" data-mp="10okhjxq2lxv0">150 Ready-to-Teach</Accent> Nail Lessons.
            </>} body="From professional foundations to advanced troubleshooting and student assessment, the system gives you a structured teaching library covering the core areas of modern nail education." data-id="element-204" data-mp="7zvn2hjisqs8" />

        <ol className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-206" data-mp="1eo28aimxfl70">
          {guides.map(guide => <li key={guide.number} className="flex h-full flex-col rounded-[18px] px-6 py-7" style={{
          backgroundColor: guide.accent
        }} data-id="element-207" data-mp="1jf24tms4w18z">
              <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/60" data-id="element-208" data-mp="7mooifnqucvx">
                Volume {guide.number}
              </p>
              <span aria-hidden="true" className="mt-3 block h-px w-8 bg-brand-gold" data-id="element-209" data-mp="mcvye6zoqnl0" />
              <h3 className="mt-4 font-display text-[1.45rem] font-bold leading-snug text-brand-charcoal" data-id="element-210" data-mp="hi9iprmkm8v4">
                {guide.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/70" data-id="element-211" data-mp="raxhut10wox0">{guide.description}</p>
            </li>)}
        </ol>

        <CtaBlock label="Get All 6 Volumes" className="mx-auto mt-14 max-w-md" data-id="element-212" data-mp="157ucl5k9iqj6" />
      </div>
    </section>;
}